import {
    ESTACIO_INICIALITZAR,
    ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES,
    ESTACIO_INTRODUCCIO_DESCARTAR_CANVIS,
    ESTACIO_INTRODUCCIO_INCIDENCIES_AFEGIR_INCIDENCIA,
    ESTACIO_INTRODUCCIO_INCIDENCIES_ELIMINAR_INCIDENCIA,
    ESTACIO_INTRODUCCIO_INCIDENCIES_MODIFICAR_INCIDENCIA
} from '../../../../actions/actionTypes';

export const ESTAT_INICIAL = {
    originals: [],
    editades: []
};

/**
 * Busca l'element d'un array i modifica el seu contingut. 
 * La funció es pura i retorna un nou array.
 * @param {array} array 
 * @param {number} indexToFind 
 * @param {object} dades 
 */
//TODO refactoritzar quan es faci el merge amb la branca NWX-486. La mateixa funció esta al reducer historicObservadors
const modificarElementDeUnaLlistaPerIndex = (array, indexABuscar, dades) => {
    return array.map((item, index) => {
        if (index !== indexABuscar) {
            return item;
        }

        return {
            ...item,
            ...dades
        };
    });
};

const incidencies = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case ESTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES:
            return {
                originals: action.estructuraIDades.dades.incidencies,
                editades: action.estructuraIDades.dades.incidencies
            };

        case ESTACIO_INTRODUCCIO_DESCARTAR_CANVIS:
            return {
                ...state,
                editades: state.originals
            };

        case ESTACIO_INTRODUCCIO_INCIDENCIES_AFEGIR_INCIDENCIA:
            if (!action.incidencia) {
                return { ...state };
            }

            return {
                ...state,
                editades: [action.incidencia, ...state.editades]
            };

        case ESTACIO_INTRODUCCIO_INCIDENCIES_ELIMINAR_INCIDENCIA:
            return {
                ...state,
                editades: state.editades.filter((item, index) => index !== action.indexIncidencia)
            };

        case ESTACIO_INTRODUCCIO_INCIDENCIES_MODIFICAR_INCIDENCIA:
            return {
                ...state,
                editades: modificarElementDeUnaLlistaPerIndex(state.editades, action.indexIncidencia, action.dadaModificada)
            };

        default:
            return state;
    }
};

export default incidencies;



// WEBPACK FOOTER //
// ./src/reducers/estacio/formulari/dades/incidencies.js